import React from "react";
import VehicleVariantSkeleton from "./VehicleVariantSkeleton";
import VehicleVariant from "./VehicleVariant";
import { useVehicleVariant } from "./useVehicleVariant";
import { VehicleDetailsHelmet } from "../../components/SellHelmets";

export default function VehicleVariantContainer() {
  const {
    bodyTypesToFilter,
    filteredVariants,
    handleSelectClick,
    loading,
    onChangeBodyType,
    openModal,
    selectedBodyType,
    setOpenModal,
    showFilter,
    showVariants,
    vehicle
  } = useVehicleVariant();

  return (
    <>
      <VehicleDetailsHelmet />
      {!vehicle ? (
        <VehicleVariantSkeleton />
      ) : (
        <VehicleVariant
          bodyTypesToFilter={bodyTypesToFilter}
          closeModal={() => setOpenModal(false)}
          filteredVariants={filteredVariants}
          handleSelectClick={handleSelectClick}
          loading={loading}
          onChangeBodyType={onChangeBodyType}
          openModal={() => setOpenModal(true)}
          selectedBodyType={selectedBodyType}
          showFilter={showFilter}
          showModal={openModal}
          showVariants={showVariants}
          vehicle={vehicle}
        />
      )}
    </>
  );
}
